<template>
    <div class="mod__downloads">
        <div v-if="!hideNavigation" class="side__menu mod__downloads--navigation" :class="{ 'is--open': menuOpen }">
            <div class="side__menu-close" data-dismiss="modal" aria-label="Close" @click="toggleResponsiveMenu()"><i
                    class="icon-ui-menu-hide pe-none"></i></div>
            <div class="side__menu-header">
                <span> {{ labels.menu }}</span>
            </div>
            <div v-if="isLoading" class="loading--container loader--center">
                <div class="spinner-border text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>

            <download-menu v-else :item="menu" ref="menu" :children="menu.children" :depth="0"
                class="side__menu-content"></download-menu>

            <div class="side__menu-footer">
                <button class="show-all active" @click="setAllButtonActive($event)">{{ allMenuButton.label }}</button>
            </div>
        </div>

        <div class="mod__downloads--container" :class="[hideNavigation ? 'full' : '']">
            <div v-show="isContentLoading" class="loading--container loader--center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <download-content v-show="!isContentLoading" @toggle-menu="toggleResponsiveMenu" :labels="labels"
                :items="items" :default-view="defaultView"></download-content>
        </div>
    </div>
</template>
<script>
import DownloadMenu from './DownloadMenu.vue';
import DownloadContent from './DownloadContent.vue';

export default {
    name: "DownloadContainer",
    props: {
        api: {
            type: String,
            default: ''
        },
        defaultView: {
            type: String,
            default: 'grid',
        },
        hideNavigation: {
            type: Boolean,
            default: false
        },
        selection: {
            type: String,
            default: ''
        },
        categories: {
            type: String,
            default: ''
        }
    },
    components: {
        DownloadContent,
        DownloadMenu
    },
    data() {
        return {
            menu: {},
            items: {},
            labels: {},
            isLoading: true,
            isContentLoading: true,
            menuOpen: false,
            init: false,
        }
    },
    computed: {
        getSelectedId() {
            return this.$root.getCategoryId()
        },
        allMenuButton() {
            return { label: this.menu.label, id: this.menu.id };
        }
    },
    watch: {
        getSelectedId() {
            if (!this.init) {
                if (this.$root.getCategoryId()) document.querySelector(".show-all").classList.remove('active');
                this.fetchItems();
            }
        }
    },
    methods: {
        toggleResponsiveMenu() {
            this.menuOpen = !this.menuOpen;
            const mediaOverlay = document.getElementsByClassName('media-overlay')[0];

            if (this.menuOpen) {
                mediaOverlay.classList.add('is--active');
                document.body.classList.add('body--overflow');

            } else {
                mediaOverlay.classList.remove('is--active');
                document.body.classList.remove('body--overflow');

            }
        },
        setAllButtonActive(e) {
            this.$root.setCategoryId(this.allMenuButton.id);
            for (const child of this.$refs.menu.$children) {
                child.closeChildren();
            }

            this.$root.setParents([]);

            const links = document.querySelector(".download--menu-item-link.active");
            if (links) links.classList.remove("active");

            const folderActive = document.querySelector(".download--menu-item.active");
            if (folderActive) folderActive.classList.remove("active");

            e.target.classList.add("active");

        },
        getJSON(url, params) {
            return new Promise((resolve, reject) => {
                const [cleanUrl, queryString] = url.split('?');
                const urlParams = {
                    ... new URLSearchParams(queryString),
                    ... Object.fromEntries(Object.entries(params).filter(([key, value]) => value))
                };
                const xhr = new XMLHttpRequest();
                xhr.open('GET', cleanUrl + '?' + new URLSearchParams(urlParams).toString(), true);
                xhr.responseType = 'json';
                xhr.onload = () => {
                    if (200 === xhr.status) return resolve(xhr.response);
                    reject(xhr);
                };
                xhr.send();
            });
        },
        fetchItems() {
            this.isContentLoading = true;
            this.items = [];
            let data = {
                "selection": this.selection,
                "categories": this.categories,
                "id": this.getSelectedId
            };
            this.getJSON(this.api, data)
                .then(response => {
                    this.items = response.items;
                    this.isContentLoading = false;
                })
                .catch(console.error);
        },
        getParents(data, id) {
            const tree = {
                children: data
            }
            return this.getParentsHelper(tree, id, []);
        },
        getParentsHelper(tree, id, parents) {
            // console.log(tree, id, parents)
            if (tree.id == id) {
                return {
                    found: true,
                    parents: parents
                };
            }

            let result = {
                found: false,
            };

            if (tree.children) {
                for (const i in tree.children) {
                    const subtree = tree.children[i]
                    const maybeParents = [].concat(...parents);

                    if (subtree.id != undefined) {
                        maybeParents.push(subtree.id);

                    }

                    const maybeResult = this.getParentsHelper(subtree, id, maybeParents);
                    if (maybeResult.found) {
                        result = maybeResult;
                        this.$root.setParents(maybeResult.parents);
                        return false;

                    }
                }
            }
            return result;
        }
    },
    mounted() {
        let data = {}
        let hash = null;
        if (window.location.hash) {
            this.init = true;
            hash = window.location.hash.substring(1);
            this.$root.setCategoryId(hash);
            data.id = hash;
            data.init = true;
        }

        if (this.hideNavigation) data.hideNavigation = 1;
        data = {"selection": this.selection,
                "categories": this.categories
        },
        this.getJSON(this.api, data)
            .then(response => {
                this.menu = response.menu ? response.menu : [];
                this.items = response.items;
                this.labels = response.labels;
                this.isLoading = false;
                this.isContentLoading = false;
                this.init = false;

                if (hash) this.getParents(this.menu.children, hash);
            })
            .catch(console.error);
        this.$root.$on('toggle-children', (value) => {
            this.getParents(this.menu.children, value);
        });
    }
}
</script>